import React from "react";
import {Route, Switch} from "react-router-dom";
import {connect} from "react-redux";
import Spacecast3d from "./spacecast3d/Spacecast3d";
import FoldersExplorer from "./folders/FoldersExplorer";
import FolderView from "./folders/FolderView";
import ItemsExplorer from "./items/ItemsExplorer";
import LinksExplorer from "./items/LinksExplorer";
import UploadsExplorer from "./items/UploadsExplorer";
import PendingExplorer from "./items/PendingExplorer";
import FavoritesExplorer from "./items/FavoritesExplorer";
import JournalExplorer from "./items/JournalExplorer";
import SpacecastExplorer from "./items/SpacecastExplorer";
import SpacecastGlobalExplorer from "./items/SpacecastGlobalExplorer";
import SurveysExplorer from "./items/ProfileExplorer";
import ImportsExplorer from "./items/ImportsExplorer";
import PhotosExplorer from "./items/PhotosExplorer";

function Explore(props) {
  const canUpload = props.user.is_admin || props.isCurrentMindfileOwner || (props.mindfile.contributors || []).some(item => item.id === props.user.uid);
  return (
    <div style={{position:'relative', height:'100%'}}>
      <div style={
        {
          padding: '1rem',
          backgroundColor: "rgba(0, 62, 88, 0.025)",
          height: '100%'
        }}>
        <Switch>
          <Route exact path="/" component={ItemsExplorer} />
          <Route exact path="/explore" component={ItemsExplorer} />
          {canUpload ? <Route path="/explore/pending" component={PendingExplorer} /> : null}
          <Route exact path="/explore/folders" component={FoldersExplorer} />
          <Route path="/explore/folder/:folderId" component={FolderView} />
          <Route path="/explore/items" component={ItemsExplorer} />
          <Route path="/explore/spacecast3d" component={Spacecast3d} />
          <Route path="/explore/uploads" component={UploadsExplorer} />
          <Route path="/explore/links" component={LinksExplorer} />
          <Route path="/explore/favorites" component={FavoritesExplorer} />
          <Route path="/explore/journal" component={JournalExplorer} />
          <Route path="/explore/profile" component={SurveysExplorer} />
          {/*<Route path="/explore/help" component={HelpPage} />*/}
          <Route path="/explore/imports" component={ImportsExplorer} />
          {/*<Route path="/explore/icons" component={IconTable} />*/}
          <Route path="/explore/spacecast/global" component={SpacecastGlobalExplorer} />
          <Route path="/explore/spacecast/personal" component={SpacecastExplorer} />
          <Route path="/explore/photo-booth" component={PhotosExplorer}/>
        </Switch>
        <div id="spacecast" style={{position:'absolute', top:0, left:0}}></div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  mindfile: state.mindfile,
});

export default connect(mapStateToProps)(Explore);
